import { GlobalHotelNotesList } from "../../../HotelNotes/List"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"
import { Helmet } from "react-helmet-async"

export default function Hotels() {
	return (
		<>
			<Helmet>
				<title>Hotels</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.UPLOAD_BULK_HOTELS}>
				<GlobalHotelNotesList />
			</ForbidUnlessAuthorized>
		</>
	)
}
